import {MaintainAppName, MaintainAppConfig} from '@hconnect/common/hproduce/maintain.types'

import {pm} from './pm'
import {rcfa} from './rcfa'

export const maintainApps: Partial<Record<MaintainAppName, MaintainAppConfig>> = {
  Maintain: rcfa,
  PM: pm
}

export const maintainAllApps = Object.values(maintainApps)
